import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export const PrivacyPage: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans antialiased">
      {/* Navbar */}
      <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-blue-600 transition-colors font-medium text-sm">
            <ArrowLeftIcon className="w-4 h-4" />
            <span>Volver a la página principal</span>
          </Link>
          <span className="font-bold text-slate-900">Políticas de Privacidad</span>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="rounded-2xl border border-slate-200 bg-white p-8 sm:p-12 shadow-sm prose prose-slate max-w-none">
          <div className="border-b border-slate-100 pb-6 mb-8">
            <p className="text-xs font-bold text-blue-600 uppercase tracking-widest">Privacidad y Habeas Data</p>
            <h1 className="text-3xl font-extrabold text-slate-900 mt-1">Políticas de Tratamiento de Datos</h1>
            <p className="text-xs text-slate-400 mt-2">Cumplimiento de la Ley 1581 de 2012 — Colombia</p>
          </div>

          <section className="space-y-6 text-slate-600 leading-relaxed text-sm sm:text-base">
            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">1. Marco Normativo</h3>
              <p>
                En estricto cumplimiento de la Ley 1581 de 2012 y el Decreto Reglamentario 1377 de 2013 sobre el régimen general de protección de datos personales en Colombia, <strong>DHING ®</strong> establece la presente Política de Privacidad para garantizar el derecho al Hábeas Data de todos los usuarios registrados en la plataforma <strong>DH Assembly</strong>.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">2. Recolección y Naturaleza de los Datos</h3>
              <p>
                Los datos personales tratados en la plataforma (tales como nombre completo, correo electrónico, número de identificación, torre, apartamento y coeficiente de copropiedad) son provistos y cargados directamente por la <strong>Administración del Conjunto Residencial</strong> en su calidad de Responsable del Tratamiento de la base de datos de la comunidad. <strong>DHING ®</strong> actúa exclusivamente como Encargado del Tratamiento tecnológico.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">3. Finalidad del Tratamiento</h3>
              <p>
                Los datos personales recolectados se utilizan con las siguientes finalidades exclusivas:
              </p>
              <ul className="list-disc list-inside space-y-1.5 mt-2 text-slate-700 font-medium">
                <li>Creación y envío seguro de credenciales de acceso para asambleas virtuales o mixtas.</li>
                <li>Verificación y auditoría de identidad para el control legal de quórum de asistencia.</li>
                <li>Ponderación automatizada del valor del voto de acuerdo con el coeficiente registrado.</li>
                <li>Generación formal de actas de asamblea con registro de decisiones y representación.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">4. Seguridad y Confidencialidad</h3>
              <p>
                <strong>DHING ®</strong> implementa medidas técnicas de alta seguridad, tales como cifrado de datos en tránsito (SSL/TLS), almacenamiento en bases de datos con acceso protegido, contraseñas cifradas con algoritmos seguros y sistemas de prevención de intrusos. Los datos no son comercializados, cedidos ni compartidos con terceros ajenos a la copropiedad bajo ninguna circunstancia.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">5. Derechos de los Titulares</h3>
              <p>
                Como titular de sus datos personales, el copropietario tiene derecho a conocer, actualizar y rectificar su información. Dado que la fuente oficial de los datos es el padrón de la copropiedad, cualquier solicitud de modificación sobre coeficientes o titularidad debe tramitarse formalmente a través de la <strong>Administración de su Conjunto Residencial</strong>.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">6. Contacto y Consultas</h3>
              <p>
                Para inquietudes técnicas relacionadas con la seguridad de la plataforma o la presente política, puede comunicarse con el equipo de soporte de <strong>DHING ®</strong> a través de nuestros canales oficiales de atención por WhatsApp.
              </p>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 mt-12 py-8 text-center text-xs text-slate-400 bg-white">
        <p>&copy; 2019-{currentYear} <strong>DHING ®</strong>. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};
export default PrivacyPage;
